import { FC } from 'react';
import { Skeleton } from 'antd';
import { NftMediaSkeleton } from 'components/Shared/NftMedia/Skeleton';
import type { TVeniceNftCardProps } from './';
import * as Styled from './styles';

export const VeniceNftCardSkeleton: FC<Partial<TVeniceNftCardProps>> = ({
  className,
  flexible = false
}) => {
  return (
    <Styled.NftCardWrapper $flexible={flexible} className={className}>
      <Styled.NftCardMediaSkeleton>
        <NftMediaSkeleton />
      </Styled.NftCardMediaSkeleton>
      <Styled.NftCardInfoWrapper>
        <Styled.DetailsWrapper>
          <Styled.NftCardName>
            <Skeleton.Button
              block
              active
              style={{
                height: '16px',
                width: '70%',
                margin: '2 0'
              }}
            />
          </Styled.NftCardName>
          <Styled.NftCardPrice>&nbsp;</Styled.NftCardPrice>
        </Styled.DetailsWrapper>

        <Skeleton.Button
          block
          active
          style={{
            height: '30px',
            width: '100%',
            margin: '2 0'
          }}
        />
      </Styled.NftCardInfoWrapper>
    </Styled.NftCardWrapper>
  );
};
